
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchUserFavorites } from './fetch-user-favorites';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  initialData?: P | null,
  token: string
};

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-user-favorites`;
};

/**
 * `useUserFavorites` hook.
 */

function useUserFavorites<P>(options?: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({
    locale,
    token: options?.token
  }), [locale, options.token]);

  const result = useQuery([actionType(variables), variables], () => {
    return fetchUserFavorites(variables);
  }, {
    initialData: options?.initialData
  });

  return result;
}

/**
 * Export `useUserFavorites` hook.
 */

export default useUserFavorites;
